import { createTheme } from "@material-ui/core/styles";
import grey from "@material-ui/core/colors/grey";

// TODO get DV repo imports to work
//import { lightTheme  } from "@dv/react-ds";
import { lightTheme } from "./lightTheme";

// TODO - import colors from DV
import * as colors from "./colors";

const green = "#74ae34";
const red = "#ca6056";
const yellow = "#e5a501";
const white = "#fff";

const DVTheme = createTheme(lightTheme, {
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: 16,
          padding: "12px 16px"
        }
      }
    },
    MuiLink: {
      styleOverrides: {
        root: {
          fontSize: 14,
          color: lightTheme.palette.links,
          fontWeight: 500,
          textDecoration: "none",
          "&:hover, &:active, &:visited": {
            color: lightTheme.palette.links,
            textDecoration: "underline"
          }
        }
      }
    },
    MuiInputLabel: {
      defaultProps: {
        shrink: false
      },
      styleOverrides: {
        root: {
          position: "static",
          transform: "none",
          fontSize: ".75rem",
          marginBottom: 4,
          "& .MuiInputLabel-asterisk": {
            color: "red" // Force red color
          }
        },
        shrink: {
          transform: "none"
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          marginTop: "4px" // adds space between label and input
        },
        notchedOutline: {
          legend: {
            display: "none"
          }
        }
      }
    }
  },

  overrides: {
    MuiAppBar: {
      root: {
        backgroundColor: "#fff",
        borderBottom: `1px solid ${[grey[300]]}`,
        boxShadow: " 1px 4px 0,rgba(0 0 0 .04)"
      },
      colorDefault: {
        backgroundColor: "#fff"
      }
    },
    MuiButton: {
      root: {
        padding: `12px 16px`,
        textTransform: "none",
        fontSize: "1rem",
        minWidth: 24
      },
      outlined: {
        borderRadius: 4,
        padding: `12px 16px`
      }
    },
    MuiTable: {
      root: {
        fontSize: "0.875rem"
      }
    },
    MuiTableHead: {
      root: {
        whiteSpace: "nowrap",
        borderTop: `1px solid ${grey[300]}`
      }
    },
    MuiTableRow: {
      head: {
        height: 48
      }
    },
    MuiTableCell: {
      root: {
        padding: "16px 12px",
        fontSize: "0.875rem",
        "&:last-child": {
          paddingRight: 12
        }
      },
      sizeSmall: {
        padding: "6px 16px 6px 12px",
        fontSize: "0.875rem"
      },
      head: {
        fontSize: "0.875rem",
        fontWeight: 700,
        color: grey[900]
      }
    },
    MuiTableSortLabel: {
      root: {
        fontSize: "0.875rem",
        fontWeight: 700,
        color: grey[900]
      },
      active: {
        color: lightTheme.palette.primary,
        "&:hover": {
          color: lightTheme.palette.primary
        },
        "&:focus": {
          color: lightTheme.palette.primary
        }
      }
    },
    MuiTabs: {
      root: {
        minHeight: 42
      }
    },
    MuiTab: {
      root: {
        border: `1px solid ${grey[400]}`,
        textTransform: "none",
        minHeight: 42,
        minWidth: "min-content !important",
        "&:not(:first-child)": {
          borderLeft: "none"
        },
        "&:first-child": {
          borderTopLeftRadius: 3,
          borderBottomLeftRadius: 3
        },
        "&:last-child": {
          borderTopRightRadius: 3,
          borderBottomRightRadius: 3,
          borderLeft: "none"
        },
        "&$selected": {
          color: grey[900],
          backgroundColor: grey[200]
        }
      },
      textColorInherit: {
        // color: primary,
        opacity: 1
      }
    },
    MuiPickersDay: {
      day: {
        color: `${lightTheme.palette.text.primary} !important`
      },
      current: {
        color: `${lightTheme.palette.primary.main}  !important`
      },
      daySelected: {
        color: `${lightTheme.palette.primary.contrastText} !important`,
        "&:hover": {
          backgroundColor: `${lightTheme.palette.primary.main} !important`
        }
      },
      dayDisabled: {
        color: `${lightTheme.palette.text.disabled}  !important`
      }
    }
  },
  border: (width = 1, style = "solid", color = grey[300]) =>
    `${width}px ${style} ${color}`,
  palette: {
    links: colors.plum[600],
    catalogColors: {
      black: {
        primary: "#000",
        secondary: "#5e5e5e",
        overlay: "#000"
      },
      purple: {
        primary: colors.plum[600],
        secondary: colors.plum[400],
        overlay: colors.plum[600]
      },
      green: {
        primary: colors.grass[500],
        secondary: colors.grass[300],
        overlay: colors.grass[500]
      },
      berry: {
        primary: colors.berry[500],
        secondary: colors.berry[300],
        overlay: colors.berry[500]
      },
      turquoise: {
        primary: colors.turquoise[500],
        secondary: colors.turquoise[300],
        overlay: colors.turquoise[500]
      }
    }
  },
  typography: {
    fontFamily: ["Roboto", "Muli", "sans-serif"].join(","),
    brand: {
      fontFamily: ["Muli", "Roboto", "sans-serif"].join(",")
    }
  },
  status: {
    primary: {
      background: lightTheme.palette.primary.main,
      color: white,
      border: "none",
      "&:hover": {
        background: lightTheme.palette.primary.dark
      }
    },
    primaryDisabled: {
      background: colors.plum[200],
      color: white,
      border: "none"
    },
    secondary: {
      background: lightTheme.palette.secondary.main,
      color: white,
      border: "none",
      "&:hover": {
        background: lightTheme.palette.secondary.dark
      }
    },
    secondaryDisabled: {
      background: colors.berry[200],
      color: white,
      border: "none"
    },
    danger: {
      background: lightTheme.palette.error.main,
      color: white,
      border: "none",
      "&:hover": {
        background: colors.tomato[800]
      }
    },
    dangerDisabled: {
      background: colors.tomato[200],
      color: white,
      border: "none"
    },
    success: {
      background: colors.grass[700],
      color: white,
      border: "none",
      "&:hover": {
        background: colors.grass[800]
      }
    },
    successDisabled: {
      background: colors.grass[200],
      color: white,
      border: "none"
    },
    warning: {
      background: colors.orange[600],
      color: white,
      border: "none",
      "&:hover": {
        background: colors.orange[700]
      }
    },
    warningDisabled: {
      background: colors.orange[200],
      color: white,
      border: "none"
    }
  },
  brandSafety: {
    suitableMost: green,
    suitableSome: yellow,
    unsuitable: red,
    notRated: grey[400],
    zeroTolerance: grey[800]
  }
});

export default DVTheme;
